import { render, staticRenderFns } from "./ContributionDropdown.vue?vue&type=template&id=8317e90e&"
import script from "./ContributionDropdown.vue?vue&type=script&lang=js&"
export * from "./ContributionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports